/*
 * @Author: hujingyang
 * @Date: 2021-01-26 17:18:42
 * @Description: 订单关怀
 * @LastEditors: Do not edit
 * @LastEditTime: 2021-03-01 09:23:59
 * @FilePath: \DouYinStore\src\pages\ordersCare\index.tsx
 * @IDE: Created by VScode.
 */


import React, { useEffect, useState } from 'react';
import { Tab } from '@alifd/next';
import style from './index.module.scss';
import utils from '@/common/utils';
import { event, store } from '@ice/stark-data';
import OrderPaymentList from '@/pages/ordersCare/components/OrderPayment/components/orderPaymentList/index';
import PaymentRecord from '@/pages/ordersCare/components/OrderPayment/components/PaymentRecord/index';
import PaymentEffect from '@/pages/ordersCare/components/OrderPayment/components/PaymentEffect/index';

const TabItem = Tab.Item;

/** 订单关怀页面 */
const orderSelection = (): JSX.Element => {
  const [currentTabKey, setCurrentTabKey] = useState('paymentDemand');// 当前tab
  const tabsList = { paymentDemand: '订单催付', paymentDemandRecord: '催付记录汇总', paymentDemandEffect: '催付效果汇总' };// tabs字典

  useEffect(() => {
    init();
  }, [currentTabKey]);

  /** 初始化函数 */
  const init = (): void => {
    getPageData();

    // 从父组件中获取已保存的currentTabKey，如果该可以为本页面tabs的key,则直接赋值，否则使用原有默认值
    const setPageTabKey = store.get('currentTab');

    // 设置当前tab 高亮
    changeTabs(tabsList[setPageTabKey] ? setPageTabKey : currentTabKey);
  };
  /**  获取数据 */
  const getPageData = (): void => {
    // 订单状态字典
  };

  /**
   * tabs 改变时触发
   * @param tabKey string
   */
  const changeTabs = (tabKey: string): void => {
    setCurrentTabKey(tabKey);

    /** 设置Header面包屑 */
    utils.setBreadcrumb({
      name: '订单关怀', // 一级页面名称
      url: '/web/ordersCare', // 一级页面url
      children: {
        name: tabsList[tabKey], // 二级页面名称
        url: '/web/ordersCare', // 二级页面url
      },
    });

    // 将当前key 传入父组件
    event.emit('currentTab', tabKey);
  };

  return (
    <>

      <div className="setTabsStyle">
        {/* 页面tabs shape="wrapped" */}
        <Tab
          animation
          navClassName={style.tabsStyle}
          onChange={changeTabs}
          activeKey={currentTabKey}
          className="tabStyle_hjy"
        >
          {Object.keys(tabsList).map((key) => {
            return (<TabItem title={tabsList[key]} key={key} />);
          })}
        </Tab>


        <div className={style.mainBox}>
          {/* Tabs - 订单催付 */}
          {currentTabKey === 'paymentDemand' && <OrderPaymentList />}

          {/* Tabs - 催付记录汇总 */}
          {currentTabKey === 'paymentDemandRecord' && <PaymentRecord />}

          {/* Tabs - 催付效果汇总 */}
          {currentTabKey === 'paymentDemandEffect' && <PaymentEffect />}


        </div>

      </div>
    </>
  );
};


export default orderSelection;
